export function vehicleBodyType(bodyStyle: string = 'sedan', model: string = 'civic') {
  if (model.indexOf('wrangler') > -1) {
    bodyStyle = 'wrangler';
  } else if (model.indexOf('gladiator') > -1) {
    bodyStyle = 'gladiator';
  }

  const vehicleMap = {
    '': 'sedan',
    convertible: 'convertible',
    coupe: 'coupe',
    gladiator: 'gladiator',
    hatchback: 'hatchback',
    passenger: 'van',
    pickup: 'truck',
    sedan: 'sedan',
    suv: 'suv',
    truck: 'truck',
    undefined: 'sedan',
    van: 'van',
    wagon: 'wagon',
    wrangler: 'wrangler',
  };

  return vehicleMap[bodyStyle];
}

export function getNumberOfRows(thirdRowSeatAvailability: string, maxSeatingCapacity: number) {
  if (maxSeatingCapacity > 5 && (thirdRowSeatAvailability === 'Standard' || thirdRowSeatAvailability === 'Optional')) {
    return 3;
  }
  if (maxSeatingCapacity > 3) {
    return 2;
  }
  return 1;
}
